import { createRef } from 'react';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import { withUIDQueryResults } from 'govbr.frontend.policy/components';
import { BlockPagination } from 'govbr.frontend.policy/components';
import WithImages from 'govbr.frontend.policy/components/BlockTemplates/Listing/WithImages';
import PropTypes from 'prop-types';
import { defineMessages } from 'react-intl';

const messages = defineMessages({
  noContent: {
    id: 'There are no contents to list.',
    defaultMessage: 'There are no contents to list.',
  },
});

export const ListingSelectionBodyBase = (props) => {
  const {
    data,
    isEditMode,
    listingItems,
    totalPages,
    currentPage,
    onPaginationChange,
    prevBatch,
    nextBatch,
    intl,
    hasLoaded,
  } = props;
  const { title, subtitle, buttonLink, buttonLabel, hideImage } = data;

  if (listingItems.length === 0) {
    return isEditMode && hasLoaded ? (
      <div className="text-danger text-center">
        {intl.formatMessage(messages.noContent)}
      </div>
    ) : null;
  }

  const listingRef = createRef();

  return (
    <div ref={listingRef} className="mb-4">
      {title || subtitle ? (
        <div className="text-center">
          {title ? <h2>{title}</h2> : null}
          {subtitle ? <p>{subtitle}</p> : null}
        </div>
      ) : null}

      <div>
        <div>
          <WithImages
            items={listingItems}
            isEditMode={isEditMode}
            hideImage={hideImage}
          />
        </div>
      </div>

      {buttonLink &&
      buttonLink.length > 0 &&
      buttonLabel &&
      buttonLabel.length > 0 ? (
        <div className="text-center">
          <UniversalLink
            item={buttonLink[0]}
            className="br-button secondary small"
          >
            {buttonLabel}
          </UniversalLink>
        </div>
      ) : null}
      <BlockPagination
        totalPages={totalPages}
        currentPage={currentPage}
        isEditMode={isEditMode}
        listingRef={listingRef}
        onPaginationChange={onPaginationChange}
        prevBatch={prevBatch}
        nextBatch={nextBatch}
      />
    </div>
  );
};

const ListingSelectionBody = withUIDQueryResults(
  ListingSelectionBodyBase,
  'contents',
  ['image_scales', 'UID', 'effective', 'modified', 'created', 'alt'],
);

ListingSelectionBody.propTypes = {
  isEditMode: PropTypes.bool,
};

export default ListingSelectionBody;
